import { Injectable } from '@angular/core';

import { ConfigurationInitService } from './configuration-init.service';

  @Injectable({
    providedIn: 'root'
  })
   export class CONFIG {

     private _configuration; 
     private _gateway;

    constructor(private configurationLoader: ConfigurationInitService) {}

    get configuration() { return this._configuration } 
    get gateway() { return this._gateway } 

    getConfiguration() { 
      this._configuration = this.configurationLoader.getConfiguration()
      return this._configuration ;
    } 

    getGateway() { 
      this._gateway = this.configurationLoader.getConfiguration().gateway;
      return this._gateway; 
    } 

   }


/*
Implementacion: 
1-inyectar servicio en constructor  private config: CONFIG
2- Modo de uso
Ej:
gateway = this.config.gateway;
url: string = `${this.gateway.url}` + (this.gateway.port==='')? '': `:${this.gateway.port}` + `/lbw`;

3-
*/